import { formatCurrency } from "../../lib/formatters.js";
import { normalizeScopeDateContext } from "../../lib/scopeDate.js";
import {
  budgetUsagePercent,
  summarizeBudgetRows,
  summarizeMonthlyExpenseRows
} from "../../lib/finance/budgetMath.js";

export {
  budgetUsagePercent,
  summarizeBudgetRows,
  summarizeMonthlyExpenseRows
};

function defaultBudgetSidebarLabel(key) {
  const text = String(key ?? "").trim();
  if (!text) {
    return "";
  }

  return text.charAt(0).toUpperCase() + text.slice(1);
}

export function createBudgetSidebarData(rows, expenseRows, dateInput, t = defaultBudgetSidebarLabel) {
  const dateContext = normalizeScopeDateContext(dateInput);
  const summary = summarizeBudgetRows(rows, expenseRows, dateContext);

  return [
    {
      key: "total",
      title: t("total"),
      rows: [
        { label: t("budget"), value: formatCurrency(summary.total.budget) },
        { label: t("spent"), value: formatCurrency(summary.total.spent) },
        {
          label: t("projected"),
          value: formatCurrency(summary.total.projected),
          statusTone: summary.total.projected <= summary.total.budget ? "good" : "bad"
        }
      ]
    },
    {
      key: "ongoing",
      title: t("ongoing"),
      rows: [
        { label: t("budget"), value: formatCurrency(summary.ongoing.budget) },
        {
          label: t("implied"),
          value: formatCurrency(summary.ongoing.implied),
          statusTone: summary.ongoing.implied <= summary.ongoing.budget ? "good" : "bad"
        }
      ]
    },
    {
      key: "irregular",
      title: t("irregular"),
      rows: [
        { label: t("budget"), value: formatCurrency(summary.irregular.budget) },
        {
          label: t("spent"),
          value: formatCurrency(summary.irregular.spent),
          statusTone: summary.irregular.spent <= summary.irregular.budget ? "good" : "bad"
        }
      ]
    }
  ];
}
